// extracted by mini-css-extract-plugin
module.exports = {"RulesPanel":"RulesPanel_RulesPanel__uJ4Ka","Table":"RulesPanel_Table__24y8M","IconImage":"RulesPanel_IconImage__2V1Vp","KendoGrid":"RulesPanel_KendoGrid__1hBJg"};